import axios from "axios";
import React, { useState, useCallback } from "react";
import { Line } from "react-chartjs-2";
import ReactModal from "react-modal";

const MiniGraficoAsistencial = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const [list1, setList1] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleOpenModalTest = () => {
    setIsOpen(true);
    cargarDatos();
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const cargarDatos = useCallback(() => {
    setLoading(true);
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: `https://suadesarrollo.azurewebsites.net/api/ObtenerPriorizados/${props.solicitud}`,
    })
      .then((response) => setList1(response.data))
      .catch(console.log)
      .finally(() => setLoading(false));
  }, [props.solicitud]);

  const filtro = list1.filter((e) => e.grupo !== "A10");

  return (
    <>
      <button className="btn btn-primary" onClick={handleOpenModalTest}>
        Ver Gráficos
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Gráficos Asistenciales"
        style={{
          content: {
            maxHeight: "80vh",
            overflow: "auto",
          },
        }}
      >
        <br></br>
        <div style={{ marginBottom: 10 }}>
          <button className="btn btn-secondary btn-sm" onClick={closeModal}>
            Volver
          </button>{" "}
          <button
            className="btn btn-outline-primary btn-sm"
            onClick={cargarDatos}
            disabled={loading}
          >
            {loading ? "Actualizando..." : "Recargar información"}
          </button>
        </div>

        {/* 🔹 CONTENEDOR GRÁFICOS */}
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {filtro.map((item, index) => {
            const lista = item.lista;

            const data = {
              labels: lista.map((e) => e.ano),
              datasets: [
                {
                  data: lista.map((e) => e.resultado),
                  borderColor: "#198754",
                  borderWidth: 2,
                  pointRadius: 2,
                  tension: 0.3,
                },
              ],
            };

            // 🔥 OPCIONES ESTABLES
            const chartOptions = {
              responsive: false, // ❗ CLAVE
              maintainAspectRatio: false,
              plugins: {
                legend: { display: false },
              },
            };

            return (
              <div
                key={index}
                style={{
                  width: "300px",
                  height: "180px",
                  margin: "20px",
                  border: "1px solid #eee",
                  borderRadius: "8px",
                  padding: "10px",
                }}
              >
                <p
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    textAlign: "center",
                    marginBottom: "6px",
                  }}
                >
                  {lista[0]?.nombreIndicador}
                </p>

                {/* 🔒 CONTENEDOR FIJO DEL CANVAS */}
                <div style={{ width: "100%", height: "130px" }}>
                  <Line
                    data={data}
                    options={chartOptions}
                    width={260} // ❗ CLAVE
                    height={120} // ❗ CLAVE
                  />
                </div>
              </div>
            );
          })}
        </div>
      </ReactModal>
    </>
  );
};

export default MiniGraficoAsistencial;
